import { Card } from "../../models/card";
export class Rock extends Card {
}
Rock.displayName = "Rock";
Rock.artUrl = "./assets/cards/rock.jpg";
